import { createFileRoute } from '@tanstack/react-router';
import { DashboardPage } from '@/features/dashboards/dashboard-page';

export const Route = createFileRoute('/w/$workspaceId/dashboards/$dashboardId')({ component: DashboardRoute });

function DashboardRoute() {
  const { dashboardId } = Route.useParams();
  return <DashboardPage key={dashboardId} dashboardId={dashboardId} />;
}
